/**
 * @generated SignedSource<<c4fbb915c9c5725010c6d52f2a4e94cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type switchSalesChannelDialogPriceQuery$variables = {
  salesChannelID: string;
};
export type switchSalesChannelDialogPriceQuery$data = {
  readonly salesChannelSwitchPrice: {
    readonly pricePerProduct: number;
    readonly productCount: number;
    readonly totalPrice: number;
  } | null;
};
export type switchSalesChannelDialogPriceQuery = {
  response: switchSalesChannelDialogPriceQuery$data;
  variables: switchSalesChannelDialogPriceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "concreteType": "ProductSwitcherPriceOutput",
    "kind": "LinkedField",
    "name": "salesChannelSwitchPrice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pricePerProduct",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "switchSalesChannelDialogPriceQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "switchSalesChannelDialogPriceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "352a93ee09bb8432b905fe61a5fbecc1",
    "id": null,
    "metadata": {},
    "name": "switchSalesChannelDialogPriceQuery",
    "operationKind": "query",
    "text": "query switchSalesChannelDialogPriceQuery(\n  $salesChannelID: ID!\n) {\n  salesChannelSwitchPrice(salesChannelID: $salesChannelID) {\n    productCount\n    totalPrice\n    pricePerProduct\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2e322e12128f5e002f1fa12f1269c9b";

export default node;
